
<template>
  <div>

      

         <md-card>
          <md-card-header>
            <div class="md-title"></div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-20">
                    <md-datepicker v-model="params.startDate">
                          <label>Inicio</label>
                      </md-datepicker>
                  </div>
                   <div class="md-layout-item md-size-20">
                    <md-datepicker v-model="params.endDate">
                          <label>Fim</label>
                      </md-datepicker>
                  </div> 
                  <div class="md-layout-item md-size-30">
                     <md-field>
                      <label>Cliente</label>
                      <md-input v-model="params.customerName"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20">
                    <md-field>
                          <label>Tid</label>
                          <md-input v-model="params.tid"></md-input>
                        </md-field>
                  </div>
                  <div class="md-layout-item md-size-20">
                    <md-field>
                          <label>Cod. Autorização</label>
                          <md-input v-model="params.code_authorization"></md-input>
                        </md-field>
                  </div>
                  <div class="md-layout-item md-size-20">
                    <md-field>
                          <label>Recorrência</label>
                          <md-input v-model="params.id_recurrent"></md-input>
                        </md-field>
                  </div>
                  
                  
            </div>   
            <div class="md-layout md-gutter">
               <div class="md-layout-item md-size-30" >
                     <md-button class="md-raised" @click="clearSearch">Limpar</md-button>
                     <md-button class="md-raised md-primary" @click="search">Buscar</md-button>
                </div>
            </div>

              </md-card-content>
        </md-card>  
        <br>    
  </div>
</template>

<script>

import search from '../../search';
 
export default {
  data(){
    return {
        companys: [],
        customers: [],
        params:{ },        
    }
  },  
  mixins:[search],
  mounted(){
      this.$material.locale.dateFormat = "dd/MM/yyyy";
  },
  methods:{     
     
    search(){
         this.$emit("search",this.params)
    },     
     
  }
};
</script>
